module.exports = __webpack_public_path__ + "static/img/step-1032.7478759.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-1032.png
// module id = TUVe
// module chunks = 1